import { rem } from 'polished'
import styled from 'styled-components'
import { AccommodationRoomTileImageContainer } from '../AccommodationRoomTileImage'
import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { isHotelPackage } from 'lib/offer/offerTypes'
import { StyledAccommodationIndividualSelectRoomTileDetails } from './AccommodationIndividualSelectRoomTileDetails'
import Sheet from 'components/utils/Sheet'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import LineArrowDownIcon from 'LuxKit/Icons/line/LineArrowDownIcon'

const CurrentSelectionBanner = styled.div`
  background-color: ${({ theme }) => theme.palette.highlight.primary.lightBackground};
  padding: ${rem(4)} ${rem(20)};
`

const AccommodationRoomTileGrid = styled(Sheet)`
  &.hasImage {
    display: grid;
    grid-template:
      "image" ${rem(210)}
      "details" auto / 1fr;
  }

  &:not(.hasImage) {
    display: grid;
    grid-template: "details" auto / 1fr;

    > ${AccommodationRoomTileImageContainer} {
      display: none;
    }
  }

  > ${AccommodationRoomTileImageContainer} {
    grid-area: image;
  }
  > ${StyledAccommodationIndividualSelectRoomTileDetails} {
    grid-area: details;
  }
`
interface Props extends PropsWithChildren {
  roomPackage: App.HotelPackage | App.BedbankPackage
  isCurrentSelection?: boolean
  imageSize?: 'small' | 'medium'
}

function AccommodationIndividualSelectRoomTile(props: Props) {
  const { roomPackage, imageSize = 'medium', isCurrentSelection, children } = props
  const room = roomPackage ? (isHotelPackage(roomPackage) ? roomPackage.roomType : roomPackage) : null

  const tile = <AccommodationRoomTileGrid
    background="neutral-eight"
    className={clsx({ hasImage: !!room?.images?.length }, `image-size-${imageSize}`)}
  >
    {children}
  </AccommodationRoomTileGrid>

  if (isCurrentSelection) {
    return <div>
      <CurrentSelectionBanner>
        <CaptionTextBlock variant="large" weight="bold" startIcon={<LineArrowDownIcon />}>
          Your current selection
        </CaptionTextBlock>
      </CurrentSelectionBanner>
      {tile}
    </div>
  } else {
    return tile
  }
}

export default AccommodationIndividualSelectRoomTile
